/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ pct: NonNullable<unknown> }} Profile_Percent_CompleteInputs */

const en_us2_profile_percent_complete = /** @type {(inputs: Profile_Percent_CompleteInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Profile ${i?.pct}% complete`)
};

const pt_br2_profile_percent_complete = /** @type {(inputs: Profile_Percent_CompleteInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Perfil ${i?.pct}% completo`)
};

const es_419_profile_percent_complete = /** @type {(inputs: Profile_Percent_CompleteInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Perfil ${i?.pct}% completo`)
};

const pt_pt2_profile_percent_complete = /** @type {(inputs: Profile_Percent_CompleteInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Perfil ${i?.pct}% completo`)
};

const fr_fr2_profile_percent_complete = /** @type {(inputs: Profile_Percent_CompleteInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Profil complet à ${i?.pct} %`)
};

const de_de2_profile_percent_complete = /** @type {(inputs: Profile_Percent_CompleteInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Profil zu ${i?.pct}% vollständig`)
};

const it_it2_profile_percent_complete = /** @type {(inputs: Profile_Percent_CompleteInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Profilo completo al ${i?.pct}%`)
};

/**
* | output |
* | --- |
* | "Profile {pct}% complete" |
*
* @param {Profile_Percent_CompleteInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_percent_complete = /** @type {((inputs: Profile_Percent_CompleteInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Percent_CompleteInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_percent_complete(inputs)
	if (locale === "es-419") return es_419_profile_percent_complete(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_percent_complete(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_percent_complete(inputs)
	if (locale === "de-DE") return de_de2_profile_percent_complete(inputs)
	if (locale === "it-IT") return it_it2_profile_percent_complete(inputs)
	return en_us2_profile_percent_complete(inputs)
});
export { profile_percent_complete as "profile.percent_complete" }